import React, { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

function money(n) {
  if (n == null) return "—";
  return typeof n === "number" ? `£${n.toLocaleString()}` : String(n);
}

export default function SalaryChangeLog() {
  const [log,     setLog]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/payroll/salary-history`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(d => setLog(Array.isArray(d) ? d : []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center gap-2">
        <TrendingUp size={14} className="text-[#00ff90]/60" />
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Salary Change History</span>
      </div>

      <div className="p-4">
        {loading && (
          <div className="space-y-2">
            {[1,2,3].map(i => <div key={i} className="h-14 rounded-lg bg-white/5 animate-pulse" />)}
          </div>
        )}
        {error && <p className="text-red-400 text-sm">⚠ {error}</p>}
        {!loading && !error && log.length === 0 && (
          <p className="text-white/20 text-sm italic py-4 text-center">No salary changes on record.</p>
        )}
        {!loading && !error && log.length > 0 && (
          <div className="space-y-2">
            {log.map((entry, i) => {
              const pct = entry.delta_pct ?? entry.deltaPct;
              const from = entry.from_salary ?? entry.from;
              const to   = entry.to_salary   ?? entry.to;
              const diff = (to && from) ? to - from : null;
              return (
                <div key={i} className="rounded-lg border border-white/5 bg-white/3 px-4 py-3">
                  <div className="flex items-center justify-between gap-3 flex-wrap">
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="text-sm text-white/70">{money(from)}</span>
                        <span className="text-white/20 text-xs">→</span>
                        <span className="text-sm font-medium text-white">{money(to)}</span>
                        {diff != null && diff > 0 && (
                          <span className="text-xs text-[#00ff90] bg-[#00ff90]/10 border border-[#00ff90]/20 px-2 py-0.5 rounded-full">
                            +{money(diff)}
                          </span>
                        )}
                      </div>
                      {entry.reason && <p className="text-xs text-white/30 mt-0.5">{entry.reason}</p>}
                    </div>
                    <div className="text-right shrink-0">
                      {pct != null && (
                        <p className="text-sm font-bold text-[#00ff90]">+{Number(pct).toFixed(1)}%</p>
                      )}
                      <p className="text-xs text-white/30">{entry.date || entry.effective_date || "—"}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}